import React, { memo } from "react";
import { observer } from "mobx-react";
import PopupForm from "app/common/Component/Popup/PopupForm";
import { Grid, Tooltip } from "@material-ui/core";
import TableComponent from "app/common/Component/Table/TableComponent";
import { useTranslation } from "react-i18next";
import { formatMoney, getDateTime } from "app/common/LocalFunction";
import CloseIcon from "@material-ui/icons/Close";
import LockIcon from "@material-ui/icons/Lock";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import { ACTIVE_STATUS, LOCKED_STATUS } from "app/common/LocalConst";
function HistoryTreatmentPopup({
  open,
  handleClose,
  searchData,
  pageDataHistory,
  handleChangeFormSearch,
}) {
  const { t } = useTranslation();

  return (
    <PopupForm
      size="lg"
      title="Lịch sử chỉnh sửa liệu trình"
      open={open}
      handleClose={handleClose}
      formik={{
        initialValues: searchData,
      }}
      hideSubmit
    >
      <Grid container spacing={1}>
        <Grid
          item
          xs={12}
          className="justify-center cards-body pt-0 mt-2"
          style={{
            zIndex: 1,
            position: "relative",
          }}
        >
          <TableComponent
            className=""
            showOrdinalNumbers
            titleNodata={t("noData")}
            data={pageDataHistory?.content}
            name="HistoryTreatment"
            showMoreButton
            minWidth={"1000"}
            columns={[
              {
                title: t("Mã đơn hàng"),
                field: "code",
              },
              {
                title: t("Tên liệu trình"),
                field: "treatmentPlanName",
                width: "360px",
                render: (row) => {
                  const displayServices = row?.paServiceRegister || [];
                  const displayMedicalSupply = row?.medicalSupplyOrders || [];
                  const displayDrugs = row?.drugs || [];
                  let itemIndex = 1;
                  return (
                    <>
                      <div className="flex mt-2" style={{ fontSize: "13px" }}>
                        <div>
                          Đã thu:{" "}
                          <b style={{ color: "green" }}>
                            {formatMoney(row?.totalBillPatientPaid || 0)}
                          </b>
                        </div>
                        <span className="mx-1">|</span>
                        <div>
                          Cần thu:{" "}
                          <b style={{ color: "red" }}>
                            {formatMoney(row?.amountActuallyPaid)}
                          </b>
                        </div>
                      </div>
                      <span className="clientCard-name">
                        {row?.clientCard?.name}
                      </span>
                      {(displayServices || []).map(
                        (serviceItem, serviceIndex) => (
                          <div
                            key={`service-${serviceIndex}`}
                            className="flex items-start mb-2"
                            style={{
                              fontSize: "14px",
                              flexDirection: "column",
                              borderBottom: "1px solid gray",
                            }}
                          >
                            <div
                              className="flex items-center flex-wrap service-info-line"
                              style={{
                                width: "100%",
                                gap: "4px",
                              }}
                            >
                              {itemIndex++}.
                              <span
                                className="text-ellipsis"
                                style={{
                                  maxWidth: "200px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {serviceItem?.service?.tradeName ||
                                  serviceItem?.service?.name ||
                                  "Tên liệu trình"}
                              </span>
                              <CloseIcon fontSize="inherit" />
                              <span className="value-medical">
                                {serviceItem?.quantity || 1}
                              </span>
                              <span className=" text-gray-400">|</span>
                              <div>
                                Điều trị:{" "}
                                <b>{serviceItem?.totalPerformedTimes || 0}</b>
                                {!serviceItem?.unLimited && (
                                  <>
                                    <span>|</span>
                                    <b style={{ color: "red" }}>
                                      {serviceItem?.totalTreatmentTimes || 0}
                                    </b>
                                  </>
                                )}
                              </div>
                              {serviceItem?.unLimited && (
                                <>
                                  <span>|</span>
                                  <Tooltip title="Không giới hạn">
                                    <span className="unlimited-badge">♾️</span>
                                  </Tooltip>
                                </>
                              )}
                              {serviceItem?.expiryDate && (
                                <>
                                  <span className="text-gray-400">|</span>
                                  <span style={{ color: "#666" }}>
                                    <b>HSD:</b>{" "}
                                    {getDateTime(serviceItem?.expiryDate)}
                                  </span>
                                </>
                              )}
                            </div>

                            <div
                              className="flex"
                              style={{
                                fontSize: "13px",
                                color: "#333",
                                width: "100%",
                                marginTop: 4,
                              }}
                            >
                              <Tooltip title="Đã thu">
                                <div>
                                  <b style={{ color: "green" }}>
                                    {formatMoney(
                                      serviceItem?.totalBillPatientPaid || 0
                                    )}
                                  </b>
                                </div>
                              </Tooltip>

                              <span className="mx-1">|</span>
                              <Tooltip title="Cần thu">
                                <div>
                                  <b style={{ color: "red" }}>
                                    {formatMoney(
                                      serviceItem?.amountActuallyPaid
                                    )}
                                  </b>
                                </div>
                              </Tooltip>
                            </div>
                          </div>
                        )
                      )}

                      {(displayDrugs || []).map((serviceItem, serviceIndex) => (
                        <div
                          key={`drug-${serviceIndex}`}
                          className="flex items-center mb-1"
                          style={{
                            fontSize: "11px",
                            flexDirection: "column",
                            borderBottom: "1px solid gray",
                          }}
                        >
                          <div
                            className="flex items-center flex-wrap"
                            style={{
                              width: "100%",
                              gap: "4px",
                              flexWrap: "wrap",
                            }}
                          >
                            {itemIndex++}.
                            <span
                              style={{
                                maxWidth: "200px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                display: "inline-block",
                                verticalAlign: "middle",
                                fontSize: "13px",
                              }}
                              title={serviceItem?.drug?.name || "Tên thuốc"}
                            >
                              {serviceItem?.drug?.name || "Tên thuốc"}
                            </span>
                            <CloseIcon fontSize="inherit" />
                            <span className="value-medical">
                              {serviceItem?.soldQuantity || 1}
                            </span>
                            {serviceItem?.unLimited && (
                              <span className="unlimited-badge">
                                ♾️ Không giới hạn
                              </span>
                            )}
                            {serviceItem?.expiryDate && (
                              <>
                                <span className="mx-1 text-gray-400">|</span>
                                <span style={{ color: "#666" }}>
                                  <b>HSD:</b>{" "}
                                  {getDateTime(serviceItem?.expiryDate)}
                                </span>
                              </>
                            )}
                          </div>
                          <div
                            className="flex"
                            style={{
                              fontSize: "13px",
                              color: "#333",
                              width: "100%",
                              marginTop: 4,
                            }}
                          >
                            <Tooltip title="Đã thu">
                              <div>
                                <b style={{ color: "green" }}>
                                  {formatMoney(
                                    serviceItem?.totalBillPatientPaid || 0
                                  )}
                                </b>
                              </div>
                            </Tooltip>

                            <span className="mx-1">|</span>
                            <Tooltip title="Cần thu">
                              <div>
                                <b style={{ color: "red" }}>
                                  {formatMoney(serviceItem?.amountActuallyPaid)}
                                </b>
                              </div>
                            </Tooltip>
                          </div>
                        </div>
                      ))}

                      {(displayMedicalSupply || []).map(
                        (serviceItem, serviceIndex) => (
                          <div
                            className="flex items-center mb-1"
                            style={{ fontSize: "13px" }}
                          >
                            <div
                              className="flex items-center"
                              style={{ borderBottom: "1px solid gray" }}
                            >
                              {itemIndex++}.
                              <span
                                style={{
                                  maxWidth: "200px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  display: "inline-block",
                                  verticalAlign: "middle",
                                }}
                                title={
                                  serviceItem?.medicalSupply?.name ||
                                  "Tên vật tư"
                                }
                              >
                                {serviceItem?.medicalSupply?.name ||
                                  "Tên vật tư"}
                              </span>
                              <CloseIcon fontSize="inherit" />
                              <span className="value-medical">
                                {serviceItem?.soldQuantity || 1}
                              </span>
                              {serviceItem?.unLimited && (
                                <span className="unlimited-badge">
                                  ♾️ Không giới hạn
                                </span>
                              )}
                            </div>
                          </div>
                        )
                      )}
                    </>
                  );
                },
              },
              {
                title: t("Giá"),
                field: "price",
                render: (row) => formatMoney(row?.price),
              },

              {
                title: t("Thành tiền"),
                field: "price",
                width: "200px",
                render: (row) => (
                  <>
                    <div className="total-data-group">
                      <div className="flex justify-between">
                        Tổng tiền: <b>{formatMoney(row?.price)}</b>
                      </div>
                      <div className="flex justify-between">
                        Giảm giá: <b>{formatMoney(row?.discount)}</b>
                      </div>
                      <div className="flex justify-between">
                        <b
                          className="flex justify-between"
                          style={{ width: "100%" }}
                        >
                          Số tiền (sau giảm):{" "}
                          <b>
                            {formatMoney(
                              row?.price * row?.quantity - (+row?.discount || 0)
                            )}
                          </b>
                        </b>
                      </div>
                      <div className="flex justify-between">
                        Vat: <b>{formatMoney(+row?.taxTotal)}</b>
                      </div>
                      <div
                        style={{
                          background: "#ccc",
                          width: "100%",
                          height: "1px",
                          margin: "4px 0",
                        }}
                      ></div>
                      <div className="flex justify-between">
                        <b
                          className="flex justify-between"
                          style={{ width: "100%" }}
                        >
                          Tổng thanh toán:{" "}
                          <b>{formatMoney(+row?.amountActuallyPaid || 0)}</b>
                        </b>
                      </div>
                      {row?.allocateDiscount ? (
                        <div>
                          <b
                            className="flex justify-between"
                            style={{ width: "100%" }}
                          >
                            Giảm tổng HĐ:{" "}
                            <b>{formatMoney(row?.allocateDiscount)}</b>
                          </b>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </>
                ),
              },
              {
                title: t("Ngày đăng ký"),
                field: "startDate",
                render: (row) => getDateTime(row?.startDate),
              },

              {
                title: t("Cơ sở"),
                field: "department?.name",
                render: (row) => row?.department?.name,
              },

              {
                title: t("Trạng thái"),
                field: "cardStatus",
                render: (row) => (
                  <>
                    {row?.cardStatus === ACTIVE_STATUS ? (
                      <Tooltip title="Đang mở">
                        <LockOpenIcon />
                      </Tooltip>
                    ) : row?.cardStatus === LOCKED_STATUS ? (
                      <Tooltip title="Đã khóa">
                        <LockIcon />
                      </Tooltip>
                    ) : (
                      ""
                    )}
                  </>
                ),
              },
              {
                field: "lockDate",
                title: t("Ngày khóa"),
                render: (row) => getDateTime(row?.lockDate),
              },
              {
                field: "createdBy",
                title: t("Người tạo"),
              },
              {
                field: "modifiedBy",
                title: t("Người sửa"),
              },
              {
                field: "modifyDate",
                title: t("Thời gian sửa (theo hệ thống)"),
                render: (row) => getDateTime(row?.modifyDate),
              },
              {
                title: t("Ghi chú"),
                field: "note",
              },
            ].filter(Boolean)}
            dataPagination={{
              pageIndex: searchData?.pageIndex,
              pageSize: searchData?.pageSize,
              totalElements: pageDataHistory?.totalElements,
              totalPages: pageDataHistory?.totalPages,
              setPageIndex: (pageIndex) =>
                handleChangeFormSearch({ pageIndex }),
              setPageSize: (pageSize) => handleChangeFormSearch({ pageSize }),
            }}
          />
        </Grid>
      </Grid>
    </PopupForm>
  );
}

export default memo(observer(HistoryTreatmentPopup));
